import storageService from './storage.js';

/**
 * Service class for glp1 treatment.
 */
export default function glp1TreatmentService() {
  const glp1_treatment_type = 'glp_1';

  /**
   * Check if the current treatment type is GLP-1.
   */
  function isGlp1TreatmentType() {
    return storageService().treatmentType === glp1_treatment_type;
  }

  /**
   * Set the default pharmacy for GLP-1 treatment
   */
  function setDefaultPharmacyForGlp1() {
    storageService().center = {
      id: '88566',
      title: 'Casa Pharma Rx',
      address: '12855 Capricorn St',
      city: 'Stafford',
      state: 'TX',
      zip: '77477',
    };
  }

  /**
   * Set the default pharmacy for GLP-1 treatment and redirect to the order page.
   */
  function afterGlp1ProductSelection() {
    setDefaultPharmacyForGlp1();
    window.location.href = '/order';
  }

  return {
    isGlp1TreatmentType,
    afterGlp1ProductSelection,
  };
}
